<template>
  <section class="section">
    <div class="container">
      <div class="section__header section__header--center">
        <span class="section__label">Интерфейс</span>
        <h2 class="section__title">Современный кабинет, которым приятно пользоваться</h2>
        <p class="section__subtitle">Тот же расчёт — на десктопе, планшете и телефоне, в светлой и тёмной теме.</p>
      </div>
      <div class="ui-strip">
        <div v-for="item in items" :key="item.title" class="ui-strip__item">
          <div class="ui-strip__icon">
            <ui-icon :name="item.icon" :size="24" />
          </div>
          <h3 class="ui-strip__title">{{ item.title }}</h3>
          <p class="ui-strip__text">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'
export default {
  name: 'InterfaceSection',
  components: { UiIcon },
  data() {
    return {
      items: [
        { icon: 'moon',       title: 'Светлая и тёмная темы', text: 'Интерфейс подстраивается под время суток и не утомляет глаза.' },
        { icon: 'smartphone', title: 'Работает на телефоне',  text: 'Адаптивная вёрстка: проверяйте начисления с любого устройства.' },
        { icon: 'bell',       title: 'Понятные уведомления',  text: 'Мгновенные подсказки-тосты вместо системных окон; интерфейс доступен и с клавиатуры.' },
      ],
    }
  },
}
</script>

<style scoped>
.ui-strip {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.ui-strip__item {
  text-align: center;
  padding: 8px 16px;
}
.ui-strip__icon {
  width: 56px; height: 56px;
  margin: 0 auto 16px;
  border-radius: var(--radius-sm);
  background: var(--primary-light);
  color: var(--primary);
  display: flex; align-items: center; justify-content: center;
}
.ui-strip__title {
  font-size: 1.0625rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--dark);
}
.ui-strip__text { color: var(--gray); font-size: 0.9375rem; line-height: 1.6; }

@media (max-width: 768px) {
  .ui-strip { grid-template-columns: 1fr; gap: 32px; }
}
</style>
